import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
    inputStyled: {
        padding: `${theme.px2rem(5)} ${theme.px2rem(10)}`,
        borderRadius: '4px',
        border: `1px solid ${theme.palette.custom.OV.sys.outline}`,
        height: theme.px2rem(55),
        font: 'inherit',
        fontSize: theme.px2rem(14),
        fontWeight: 500,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        '& > div': {
            width: '100%',
        },
        '&:hover': {
            border: `1px solid ${theme.palette.common.black}`,
        },
        '@media (prefers-color-scheme: dark)': {
            '&:hover': {
                border: `1px solid ${theme.palette.common.white}`,
            },
        },
    },
    focused: {
        '&, &:hover': {
            border: '1px solid #2AC5C9',
        },
    },
}));
